module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjgwMCI+PHBhdGggZmlsbD0iI0UzMEExNyIgZD0iTTAgMGgxMjAwdjgwMEgweiIvPjxjaXJjbGUgY3g9IjQyNSIgY3k9IjQwMCIgcj0iMjAwIiBmaWxsPSIjZmZmIi8+PGNpcmNsZSBjeD0iNDc1IiBjeT0iNDAwIiByPSIxNjAiIGZpbGw9IiNlMzBhMTciLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNTgzLjMzNCA0MDBsMTgwLjkwMSA1OC43NzktMTExLjgwNC0xNTMuODg1djE5MC4yMTJsMTExLjgwNC0xNTMuODg1eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/tur.svg
// module id = 4kv+
// module chunks = 0